import * as React from 'react';
import { AnchorListItem } from './AnchorListItem';
import { AppName } from '@pec/aion-ui-core/interfaces/appName';
import { faHardHat } from '@fortawesome/free-solid-svg-icons/faHardHat';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLinkListItem } from './NavLinkListItem';
import { SectionContainer } from '../../containers/Nav/Section';
import { useTranslation } from 'react-i18next';

const { AionSafetyProgramsUI } = AppName;

export const SafetyProgramsSection: React.FC = () => {
  const { t } = useTranslation();
  return (
    <SectionContainer
      id={AionSafetyProgramsUI}
      subheader={t('components.safetyProgramsSection.programReviews', 'Program Reviews')}
      icon={<FontAwesomeIcon icon={faHardHat} />}
    >
      {process.env.REACT_APP_NAME === AionSafetyProgramsUI ? (
        <React.Fragment>
          <NavLinkListItem inset to="/safety-programs/clients">
            {t('components.safetyProgramsSection.assignProgramReviews', 'Assign Program Reviews')}
          </NavLinkListItem>
          <NavLinkListItem inset to="/safety-program-requirements">
            {t('components.safetyProgramsSection.contractorEvaluations', 'Contractor Evaluations')}
          </NavLinkListItem>
          <NavLinkListItem inset exact to="/safety-programs">
            {t('components.safetyProgramsSection.programEditor', 'Program Editor')}
          </NavLinkListItem>
          <AnchorListItem inset href="/safety-programs/reports">
            {t('components.safetyProgramsSection.reports', 'Reports')}
          </AnchorListItem>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <AnchorListItem inset href="/safety-programs/clients">
            {t('components.safetyProgramsSection.assignProgramReviews', 'Assign Program Reviews')}
          </AnchorListItem>
          <AnchorListItem inset href="/safety-program-requirements">
            {t('components.safetyProgramsSection.contractorEvaluations', 'Contractor Evaluations')}
          </AnchorListItem>
          <AnchorListItem inset href="/safety-programs">
            {t('components.safetyProgramsSection.programEditor', 'Program Editor')}
          </AnchorListItem>
          <AnchorListItem inset href="/safety-programs/reports">
            {t('components.safetyProgramsSection.reports', 'Reports')}
          </AnchorListItem>
        </React.Fragment>
      )}
    </SectionContainer>
  );
};
